<template>
  <div id="creator_daily_income" :class="isFull === 1 ? 'bdm_center0 top_information1' : ' bdm_center0'">
    <van-nav-bar :title="$t('title.creator_daily_income')" placeholder fixed @click-left="onClickLeft" left-arrow />
    <van-row>
      <!--   列表   -->
      <van-col span="24">
          <van-col span="22" offset="1" class="creator_daily_income_list" v-for="(t,j) in list" :key="j">
           <van-col span="11" offset="1" class="creator_daily_income_list_name">{{ t.content }}</van-col>
           <van-col span="11">
             <van-col span="24" class="creator_daily_income_list_number">
               <img src="../assets/img/coin9.png"/> +{{ t.profit }}
             </van-col>
             <van-col span="24" class="creator_daily_income_list_time">{{ t.create_time }}</van-col>
           </van-col>
          </van-col>
      </van-col>
    </van-row>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"

export default {
  data() {
    return {
      date: undefined,
      list: [],
      isFull: 0,
    }
  },
  created() {
    this.isFull = this.$route.query.is_full == 1 ? 1 : 0 // is_full=1 显示信号栏
    this.date = this.$route.query.date
    this.getList()
  },
  methods: {
    getList(){
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=creator&act=creator_user_daily_income",{
        params:{uid: uid, token: token, date: this.date }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        console.log(res.data)
        if(res.data.status===1){
          this.list = res.data.data.list
        }else{
          Toast(res.data.error)
        }
      })
    },
    onClickLeft() {
      // 返回上一页
      this.$router.go(-1);
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/creator_daily_income.vue